<template>
  <div class="progress_sections">
    <div v-for="item in items" :key="item.label" class="progress_item">
      <!-- Label with bulma tooltip for long text -->
      <div class="label_wrapper" :class="{ 'has-tooltip-right': item.label.length > 18 }"
        :data-tooltip="item.label.length > 18 ? item.label : null">
        <span class="item_label">
          {{ item.label }}
        </span>
      </div>

      <!-- Progress bar and percentage container -->
      <div class="progress_bar_wrapper">
        <div class="progress_bar_container">
          <div class="progress_bar_fill" :style="{ width: item.percent + '%', '--progress-bar-color': item.color }"></div>
        </div>
        <span class="item_percent">
          <span class="separator">·</span>
          {{ item.percent }}%
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBarSection',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.progress_sections {
  width: 100%;
}

.progress_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  gap: 12px;
}

.label_wrapper {
  flex: 1;
  min-width: 30%;
  max-width: 50%;
  display: flex;
}

.item_label {
  font-size: 14px;
  color: #111827;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.progress_bar_wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 50%; // Fixed 50% width to ensure all bars are identical
  justify-content: flex-end;
}

.progress_bar_container {
  height: 18px;
  background: #f1f3f5;
  border-radius: 4px;
  overflow: hidden;
  flex: 1;
}

.progress_bar_fill {
  height: 100%;
  background: var(--progress-bar-color, #008080); // Default to teal
  border-radius: 2px;
  transition: width 0.3s ease-in-out;
}

.item_percent {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.separator {
  color: #d1d5db;
  font-weight: bold;
  font-size: 16px;
}
</style>
